// BonBoZ: đọc ngược "thả cảm xúc" của cầu nối Zalo ra khỏi dòng tin nhắn.
//
// Zalo có thả cảm xúc, Chatwoot thì không có khái niệm đó, nên cầu nối
// (`zalo_bridge/src/handlers/events.ts`) gửi vào một GHI CHÚ RIÊNG:
//
//   `${emoji} ${ai} đã thả cảm xúc`   kèm `in_reply_to` trỏ về tin được thả
//
// Đọc thẳng thì mỗi lần ai đó thả tim là khung chat mọc thêm một bong bóng, bên
// trên còn kẹp cả bản trích dẫn của tin gốc — một hành động một chạm biến thành
// khối to hơn chính tin nhắn. Nhóm đông người thì lấp kín cả cuộc trò chuyện.
//
// Bóc ở đây để danh sách tin GIẤU ghi chú đó đi và vẽ cảm xúc thành một chip
// nhỏ dính vào đúng tin gốc, giống Zalo và Messenger.
//
// SAO KHÔNG SỬA CẦU NỐI CHO GỌN HƠN: API công khai của Chatwoot không cho ghi
// `content_attributes` tuỳ ý lên một tin đã có (`messages_controller.rb` chỉ
// nhận `status` và `external_error`). Muốn đi đường có cấu trúc thì phải mở
// thêm một endpoint riêng — mà cách này chạy được ngay với cả những cảm xúc đã
// nằm sẵn trong lịch sử.

// `\S+` cho emoji: ❤️ là hai điểm mã (U+2764 U+FE0F) nên không dùng `.` được.
// Tên người có dấu cách ("Bạn (từ app Zalo)") nên phần giữa phải tham lam vừa đủ.
const RE = /^(\S+)\s+([\s\S]*?)\s*đã thả cảm xúc\s*$/u;

/**
 * @param {Object} message Tin đã qua camelCase của MessageList.
 * @returns {{ emoji: string, who: string, targetId: number }|null}
 *   `null` nếu đây không phải ghi chú cảm xúc.
 */
export function parseZaloReaction(message) {
  if (!message?.private) return null;

  // Không có tin gốc thì không có chỗ để dính vào — cứ để nó hiện như tin
  // thường còn hơn nuốt mất thông tin.
  const targetId = message.contentAttributes?.inReplyTo;
  if (!targetId) return null;

  const found = String(message.content ?? '').match(RE);
  if (!found) return null;

  return { emoji: found[1], who: found[2].trim(), targetId };
}

/**
 * Gom cảm xúc theo tin được thả.
 *
 * @param {Array} messages Danh sách tin đã camelCase.
 * @returns {{ reactionsByTarget: Map<number, Array>, reactionNoteIds: Set<number> }}
 */
export function collectZaloReactions(messages = []) {
  const reactionsByTarget = new Map();
  const reactionNoteIds = new Set();

  messages.forEach(message => {
    const reaction = parseZaloReaction(message);
    if (!reaction) return;

    reactionNoteIds.add(message.id);
    const list = reactionsByTarget.get(reaction.targetId) ?? [];
    list.push({ ...reaction, id: message.id });
    reactionsByTarget.set(reaction.targetId, list);
  });

  return { reactionsByTarget, reactionNoteIds };
}
